import {useState} from "react";
import {LucideFlame, LucideMenu, LucideX} from "lucide-react";
import {SimpleLink} from "../common/SimpleLink";
import {BolFireStrikePage} from "../../pages/HomePage";

const navItems = [
    {name: "Producten", href: "#producten"},
    {name: "Voordelen", href: "#voordelen"},
    {name: "Instructies", href: "#instructies"},
    {name: "Reviews", href: "#reviews"},
];

export const AppHeader = () => {
    const [open, setOpen] = useState(false);

    return (
        <header className="bg-ink-950/80 backdrop-blur-md border-b border-ink-700/70 sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center py-4">

                    <a href="/" className="flex items-center gap-2.5 shrink-0">
                        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-fire-gradient shadow-ember-sm">
                            <LucideFlame className="h-5 w-5 text-white" />
                        </span>
                        <span className="font-display text-xl font-bold tracking-wide text-ink-50">
                            FIRE STRIKE
                        </span>
                    </a>

                    <nav className="hidden md:flex items-center gap-8">
                        {navItems.map(item => (
                            <SimpleLink key={item.href} name={item.name} href={item.href} />
                        ))}
                    </nav>

                    <div className="hidden md:block">
                        <BuyNowButton />
                    </div>

                    <button
                        className="md:hidden text-ink-100 p-1"
                        aria-label="Menu"
                        onClick={() => setOpen(v => !v)}
                    >
                        {open ? <LucideX className="h-6 w-6" /> : <LucideMenu className="h-6 w-6" />}
                    </button>
                </div>
            </div>

            {open && (
                <div className="md:hidden border-t border-ink-700/70 bg-ink-950/95 backdrop-blur-md">
                    <nav className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-4">
                        {navItems.map(item => (
                            <SimpleLink
                                key={item.href}
                                name={item.name}
                                href={item.href}
                                classNames="text-lg py-1"
                            />
                        ))}
                        <BuyNowButton />
                    </nav>
                </div>
            )}
        </header>
    );
};

const BuyNowButton = () => {
    return (
        <button
            onClick={() => window.open(BolFireStrikePage, "_blank")}
            className="inline-flex items-center justify-center gap-2 bg-fire-gradient text-white px-6 py-2.5 rounded-lg
                       font-semibold shadow-ember-sm hover:brightness-110 hover:scale-[1.02] transition-all"
        >
            <LucideFlame className="h-4 w-4" />
            Koop Nu
        </button>
    );
};
